export const SERVERURL = 'https://Sparrow-Media-backend.prakhar10v.repl.co';
